















































































import { Vue, Component } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import {
  ExamResultsQuery, ExamResultsQuerySymbol,
  ExamStoreModule, ExamStoreModuleSymbol
} from '../state'
import { ExamItem, ExamResult } from '@/app/exam/ui/exam-dashboard-types';
import { examsDashboardMixin } from '@/app/exam/ui/exams-dashboard-mixin';
import ExamsMobileDashboardComponent from '@/app/exam/ui/exams-mobile-dashboard-component.vue';
import LoadingComponent from '@/app/shared/components/loading-component.vue';
import FinalExamDashboardButtonComponent from '@/app/exam/ui/final-exam-dashboard-button-component.vue';
import ExamResultsDashboardTableComponent from '@/app/exam/ui/exam-results-dashboard-table-component.vue';
import UiProgressRingComponent from '@/app/shared/components/ui/ui-progress-ring-component.vue';
import WrapperSimpleComponent from '@/app/shared/components/wrapper/wrapper-simple-component.vue';
import WrapperCommonComponent from '@/app/shared/components/wrapper/wrapper-common-component.vue';
import UiPagerComponent from '@/app/shared/components/ui/ui-pager-component.vue';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";
import {setFocus} from '@/app/accessibility/accessibility-utils';
import { examScoreDisplay, examPercentDisplay } from './exam-score-display'

@Component({
  components: {
    ExamsMobileDashboardComponent,
    LoadingComponent,
    FinalExamDashboardButtonComponent,
    ExamResultsDashboardTableComponent,
    UiProgressRingComponent,
    WrapperSimpleComponent,
    WrapperCommonComponent,
    UiPagerComponent,
    HelpPopupComponent
  },
  mixins: [
    examsDashboardMixin
  ]
})
export default class ExamsDashboardComponent extends Vue {

  public selectedExamTab: 'remaining'|'performed' = 'remaining';

  @lazyInject(ExamResultsQuerySymbol)
  private examResults: ExamResultsQuery;

  @lazyInject(ExamStoreModuleSymbol)
  private examStore: ExamStoreModule;

  public get loading(): boolean {
    return this.loadingPhase === 'loading' || this.queryTrackingPhase === 'loading';
  }

  public get finalExam(): ExamItem | null {
    const merged = this.mergedResultsWithExams;
    const final = merged.find(x => x.role === 'final');
    return final || null;
  }

  public get remainingExams(): ExamItem[] {
    return this.nonFinalExams
      .filter(x => x.status === 'not-attempted' || x.effectiveAttempt.result === 'failed');
  }

  public get passedExams(): ExamItem[] {
    return this.nonFinalExams
      .filter(x => x.status === 'completed' && x.effectiveAttempt.result === 'passed');
  }

  private get nonFinalExams(): ExamItem[] {
    const merged = this.mergedResultsWithExams;
    return merged.filter(x => x.role !== 'final');
  }

  private get mergedResultsWithExams() {
    const exams = this.examStore.exams
    const results = this.examResults.examResults

    const merged: ExamItem[] = []

    for (let exam of exams) {
      const result = results.find(x => x.id === exam.id)

      const details = {
        id: exam.id,
        title: exam.title,
        role: exam.role,
        href: exam.href,
        parentTitle: exam.parentTitle,
        gradingMethod: exam.gradingMethod,
        attemptCount: result ? result.attemptCount : 0
      }

      let item: ExamItem
      if (result) {
        item = {
          ...details,
          status: 'completed',
          effectiveAttempt: {
            result: result.result,
            score: {
              min: examScoreDisplay(result.score.min),
              max: examScoreDisplay(result.score.max),
              raw: examScoreDisplay(result.score.raw),
              percent: examPercentDisplay(result.score.percent)
            },
            timestamp: result.timestamp
          }
        }
      } else {
        item = {
          ...details,
          status: 'not-attempted'
        }
      }

      merged.push(item);
    }

    return merged
  }

  get loadingPhase() {
    return this.examStore.loadingPhase
  }

  get queryTrackingPhase() {
    return this.examResults.remotePhase
  }

  public get hasExams() {
    return !!this.passedExams.length || !!this.remainingExams.length
  }

  public get hasFinalExamInCourse(): boolean {
    const merged = this.mergedResultsWithExams;
    return merged.find(x => x.role === 'final') !== undefined;
  }

  public onArrowKey(nextTabId: string): void {
    setFocus(`#${nextTabId}`);
  }
}
